import React, {
  createContext, useContext, useEffect, useMemo, useState,
} from 'react';

interface PwaPromptState {
  promptEvent?: BeforeInstallPromptEvent;
}

const PwaPromptContext = createContext<PwaPromptState>({});

interface PwaPromptProviderProps {
  children: React.ReactNode;
}

export function PwaPromptProvider({ children }: PwaPromptProviderProps) {
  const [promptEvent, setPromptEvent] = useState<BeforeInstallPromptEvent>();

  useEffect(() => {
    const handleBeforeInstallPrompt = (event: Event) => {
      setPromptEvent(event as BeforeInstallPromptEvent);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const value = useMemo(() => ({ promptEvent }), [promptEvent]);

  return <PwaPromptContext.Provider value={value}>{children}</PwaPromptContext.Provider>;
}

export const usePwaPrompt = () => useContext(PwaPromptContext);
